import { Component, OnInit } from '@angular/core';
import {ServicesComponent} from "../services.component";

@Component({
  selector: 'app-web-design',
  template: `
     <div class="service-detail" id="top">
        <h2><span class="bottomBorder" style="padding-bottom: 4%;">WEB</span> DESIGN</h2>
        <div class="scale-less-margin"></div>
        <article>Every company is different, that why the Creative Digital team design your website to truly reflect your business.
          We like to get to know our customers and build websites that engage with potential new customers.
         </article>
        <article style="margin-bottom: 6%">We build features to fit your business needs, from bespoke contact forms to dedicated content management systems for your products and services.
        </article>
        <div class="details-container first">
          <div class="checked"></div>
          <h5>Landing Page</h5></div>
        <p style="display: block" class="slider">Landing page is the great first step to start building your online presents. Custom landing page with unique design will raise your sales
        and move your business even further.
        </p>
        <div class="details-container second">
          <div class="checkMark"></div>
          <h5>Web Site</h5></div>
        <p class="slider">In Creative Digital we are able to build a beautifully made custom websites that are able to communicate with your clients and attract attention. </p>
        <div class="details-container forth">
          <div class="checkMark corporate"></div>
          <h5>Corporate site</h5></div>
        <p class="slider">If you want to make your company more open to the public and share your success and goals with the whole world — Corporate website is exactly what 
         you need.</p>
      </div>
  `,
  styleUrls: ['./web-design.component.css']
})
export class WebDesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.slider();
    WebDesignComponent.firstStart(this, 1);
  }

  slider () {
    $('.first').click(function () {
    WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

  static firstStart(activeEl: any, elementNumber: number){
    $('.shadow').removeClass('shadow');
    $('.service:nth-child(' + elementNumber +')').addClass('shadow');
    $('.first').addClass('activeSlider');
    ServicesComponent.toTheTop();
  }

  static initializeSlide(activeEl: any) {
    let slider = $('.slider');
    slider.slideUp(500);
    let activeElement = $(activeEl);
    $('.activeSlider').removeClass('activeSlider');
    activeElement.addClass('activeSlider');
    activeElement.next('p').slideDown(500);
    let currentCheck = $('.checked');
    currentCheck.addClass('checkMark');
    currentCheck.removeClass('checked');
    let check = activeElement.find('.checkMark').first();
    check.removeClass('checkMark');
    check.addClass('checked');
  }


}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/descriptionComponents/web-design.component.ts